import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-03jurassic_verticalalign_top",
  "use": "icon-03jurassic_verticalalign_top-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-03jurassic_verticalalign_top\"><path d=\"M64 64h896v64H64z\" fill=\"#727272\" /><path d=\"M192 960V192h256v768z\" fill=\"#497CAD\" /><path d=\"M576 704V192h256v512z\" fill=\"#B3B3B3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol